/**
 * Transforme la réponse de GET /hr/pilotage/taches en modèle
 * consommé par TachesSection.
 */
export const mapTaches = (api) => {
    const vacancesAllouees = api.vacation_allocated ?? 0;
    const vacancesConsommees = api.vacation_taken ?? 0;

    return {
        absencesJour: api.absences_today ?? 0,
        tachesEchues: api.overdue_tasks ?? 0,
        vacancesAllouees,
        vacancesConsommees,
        vacancesDisponibles: api.vacation_available ?? 0,
        vacancesConsommeesPct:
            vacancesAllouees > 0
                ? Math.round((vacancesConsommees / vacancesAllouees) * 100)
                : 0,
        validationFeuilles: api.timesheet_validation_pct ?? 0,
        envoiFeuilles: api.timesheet_submission_pct ?? 0,
        onboardingsEnCours: api.onboardings_in_progress ?? 0,
        offboardingsEnCours: api.offboardings_in_progress ?? 0,
    };
};
